import { authApi } from 'api';

/**
 * Linked roster changes — the change-preview model (docs/role-and-deletion-design.html §5.6).
 * preview is a dry-run that returns the ChangePlan; apply re-runs and executes it.
 */

/**
 * Preview a linked remove (dry-run). Seeds are athlete profile IDs and/or user IDs.
 * @param {string} clubId
 * @param {{athleteIds?: string[], userIds?: string[]}} seed
 * @returns {Promise} response whose .data is a ChangePlan
 */
export const previewRemove = async (clubId, seed) => {
  return await authApi.post(`/clubs/${clubId}/roster-changes/remove/preview`, {
    athleteIds: seed.athleteIds || [],
    userIds: seed.userIds || [],
  });
};

/**
 * Apply a linked remove. Sends the same seed as the preview; the server re-resolves and executes.
 * @param {string} clubId
 * @param {{athleteIds?: string[], userIds?: string[]}} seed
 * @returns {Promise} response whose .data is a ChangeApplyResult
 */
export const applyRemove = async (clubId, seed) => {
  return await authApi.post(`/clubs/${clubId}/roster-changes/remove/apply`, {
    athleteIds: seed.athleteIds || [],
    userIds: seed.userIds || [],
  });
};
